<template>
  <div class="">
    <div class="mb-4 flex justify-between items-center">
      <h2 class="text-lg font-semibold text-gray-900">Patient Appointment Records</h2>
      <ExportMenu
        :disabled="!rowData.length"
        :exports="[{ type: 'excel', action: exportToExcel }]"
      />
    </div>

    <div style="height: 500px;">
      <AgGridVue
        :theme="compactListTheme"
        style="width: 100%; height:100%"
        :column-defs="columnDefs"
        :row-data="rowData"
        :default-col-def="defaultColDef"
        :grid-options="gridOptions"
        :loading="loading"
        @grid-ready="onGridReady"
      />

    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import axios from 'axios';
import { AgGridVue } from 'ag-grid-vue3';
import {compactListTheme} from '@/utils/common';
import ExportMenu from '@/components/widgetcomponents/library/ExportMenu.vue';

export default defineComponent({
  name: 'Patient_Attribution_Table',
  computed: {
    compactListTheme() {
      return compactListTheme
    },
  },
  components: {
    AgGridVue,
    ExportMenu,
  },
  props: {
    patientIdentifier: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      rowData: [],
      gridApi: null,
      gridOptions: {
        suppressAggFuncInHeader: true,
        domLayout: this.autoHeight ? 'autoHeight':null
      },
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
      },

      columnDefs: [
        {
          field:'practice_name',
          headerName:'Practice',
          cellClass: 'sensitive',
        },
        {
          field: 'appointment_date',
          headerName: 'Appointment Date',
          valueFormatter: this.dateFormatter,
          sort: 'desc',
        },
        {
          field: 'begin_time',
          headerName: 'Start Time',
          valueFormatter: params => {
            if (!params.value) return '';
            const date = new Date(params.value);
            if (isNaN(date)) return params.value;
            return date.toLocaleTimeString('en-US', {
              hour: '2-digit',
              minute: '2-digit',
              hour12: true
            });
          }
        },
        {
          field: 'end_time',
          headerName: 'End Time',
          valueFormatter: params => {
            if (!params.value) return '';
            const date = new Date(params.value);
            if (isNaN(date)) return params.value;
            return date.toLocaleTimeString('en-US', {
              hour: '2-digit',
              minute: '2-digit',
              hour12: true
            });
          }
        },
        {
          field: 'duration',
          headerName: 'Duration',
          valueFormatter: params => params.value ? `${params.value} min` : ''
        },
        {
          field: 'appt_type_long',
          headerName: 'Appointment Type',
        },
        {
          field: 'reason',
          headerName: 'Reason',
        },
        {
          field: 'status',
          headerName: 'Status',
        },
        {
          field: 'provider_clinician_name',
          headerName: 'Provider',
          cellClass: 'sensitive',
        },
        {
          field: 'resource',
          headerName: 'Resource/Location',
        },
        {
          field: 'delete_indicator',
          headerName: 'Deleted?',
        },
        {
          field: 'npi',
          headerName: 'NPI',
        },
        {
          field: 'detail',
          headerName: 'Additional Details',
        },
      ]
    };
  },
  methods: {
    async fetchData() {
      this.loading = true;

      try {
        const response = await axios.post('api/returnpatientdata/', {
          data_type: 'appointments',
          patient_identifier: this.patientIdentifier,
        });

        this.rowData = response.data || [];
      } catch (error) {
        console.error('Error fetching attribution data:', error);
        this.rowData = [];
      } finally {
        this.loading = false;
      }
    },

    onGridReady(params) {
      this.gridApi = params.api;
      params.api.sizeColumnsToFit();
      window.addEventListener('resize', this.onWindowResize);

    },

    exportToExcel() {
      if (this.gridApi) {
        if (this.$root?.isDemoMode) return; // Demo Mode: block raw-data export
        this.gridApi.exportDataAsExcel({
          fileName: `patient_attribution_${this.patientIdentifier}_${new Date().toISOString().split('T')[0]}.xlsx`,
          sheetName: 'Attribution'
        });
      }
    },
    onWindowResize() {
      if (this.gridApi) {
        this.gridApi.sizeColumnsToFit();
      }
    },
    dateFormatter(params) {
      if (!params.value) return '';
      const date = new Date(params.value + 'T00:00:00');
      if (isNaN(date)) return params.value;
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    }
  },
  mounted() {
    this.fetchData();
  }
});
</script>

<style scoped>

</style>
